<template>
    <div class="image-bar">
  <img src="/assets/img/partners/elavon-logo.png" alt="Image 1" class="bar-image" />
  <img src="/assets/img/partners/sunmi-logo.png" alt="Image 2" class="bar-image" />
  <img src="/assets/img/partners/pax-logo.webp" alt="Image 3" class="bar-image" />
  <img src="/assets/img/partners/liberis-logo.png" alt="Image 4" class="bar-image" />
</div>
</template>

<style>
.image-bar {
  width: 100vw;
  display: flex;
  flex-wrap: wrap; /* Allow items to wrap onto next line */
  justify-content: space-around; /* Optional: center images when wrapped */
  align-items: center;
  background-color: var(--primary);
  padding: 1.5rem 4rem;
  gap: 2rem; /* Optional: adds space between rows/columns */
}


.bar-image {
  max-width: 100px;
  height: auto;
  object-fit: contain;
}
</style>